import { EntityDocfile } from "../../entity/EntityDocfile";

export class DtoDocfilesPostRes extends EntityDocfile {}
